import Request from "../constants/Request.api"
import Api from "../Api"

import Staff from "../staff/Staff"

import PlasticsOfficer from "./plasticsAuthorisation/PlasticsOfficer.service"
import PlasticsDG from "./plasticsAuthorisation/PlasticsDG.service"
import PlasticsHead from "./plasticsAuthorisation/PlasticsHead.service"

const staffService = new Staff()

class Application extends Api {
  constructor(user) {
    super()
    this.user = user
  }
  getStrategy = type => {
    let appObj = null
    switch (type) {
      case "officer":
        appObj = new PlasticsOfficer(this.user)
        break
      case "head":
        appObj = new PlasticsHead(this.user)
        break
      case "dg":
        appObj = new PlasticsDG(this.user)
      default:
        break
    }

    return appObj
  }

  getApplicationDetails = id => {
    const request = new Request({
      data: {
        url: "application/" + id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  assignStaff = data => {
    const request = new Request({
      data: {
        staff_id: data.staff_id,
        assigned_by: data.assigned_by,
        application_id: data.application_id,
        url: "applications/assign",
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getAssignedTo(application_id) {
    const request = new Request({
      data: {
        url: "application/assigned-to/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getStatusCodeFromName(name) {
    const request = new Request({
      data: {
        url: "application/status-code/" + name,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getHistory = appId => {
    const request = new Request({
      data: {
        url: "application/history?application_id=" + appId,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getStatistics = () => {
    let url = "staff/statistics/" + this.user.id
    if (this.user.position_id === 2) {
      url = "department/statistics/" + this.user.department_id
    } else if (this.user.position_id === 3) {
      url = "portal/statistics"
    }
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getRecycledStatistics = () => {
    let url = "plastics/dashboards"
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDecisons = () => {
    const request = new Request({
      data: {
        token: "Bearer " + this.user.token,
      },
    })
  }

  // old implementation
  // downloadAttachment = file => {
  //   const request = new Request({
  //     data: {
  //       url: "service/download-attachment?file=" + file,
  //       token: "Bearer " + this.user.token,
  //     },
  //   })

  //   return this.downloadRequest(request)
  // }

  // Nov 2025
  downloadAttachment = fileId => {
    console.log(fileId)
    const request = new Request({
      data: {
        url: "files/download/" + fileId,
        //file: file,
        token: "Bearer " + this.user.token,
      },
    })

    return this.downloadRequestBlob(request)
  }

  getDepartmentOfficers = department_id => {
    const request = new Request({
      data: {
        url: "staff/department-officers/" + department_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  //  Basel Application
  getClientWasteIds = application_id => {
    const request = new Request({
      data: {
        url: "waste-identifications-applicant/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getTransitStates = application_id => {
    const request = new Request({
      data: {
        url: "transit-states/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  reviewApplicationOfficer = data => {
    const request = new Request({
      data: {
        url: "staff/application/review/" + data.application_id,
        ...data,
        decision_code: data.decision_code,
        reason: data.reason,
        comment_to_applicant: data.comment_to_applicant,
        manually_processed: data.manually_processed,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  reviewApplicationHead = data => {
    const request = new Request({
      data: {
        ...data,
        reason: data.reason,
        comment_to_applicant: data.comment_to_applicant,
        decision_code: data.decision_code,
        application_id: data.application_id,
        url: "staff/application/department/review/" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  reviewApplicationDirector = data => {
  //  console.log("token --> ", this.user.token)
    const request = new Request({
      data: {
        ...data,
        reason: data.reason,
        decision_code: data.decision_code,
        application_id: data.application_id,
        url: "staff/application/dg/review/" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  // downloadAttachment = file => {
  //   const request = new Request({
  //     data: {
  //       url: "service/download-attachment?file=" + file,
  //       token: "Bearer " + this.user.token,
  //     },
  //   })

  //   return this.downloadRequest(request)
  // }

  getHoDReviewDetails = application_id => {
    const request = new Request({
      data: {
        url: "application/hod-review?application_id=" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getOfficerReviewDetails = data => {
    const request = new Request({
      data: {
        url:
          "application/officer-review?staff_id=" +
          data.staff_id +
          "&application_id=" +
          data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getDirectorReviewDetails = application_id => {
    const request = new Request({
      data: {
        url: "application/director-review?application_id=" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  uploadFile = fileDetails => {
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", fileDetails.application_id)
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        // url: "applications/upload/file",
        url: "application-files/upload",
        token: "Bearer " + this.user.token,
      },
    })
    return this.uploadRequest(request)
  }

  uploadSignedManualCertificate = (fileDetails) => {
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", fileDetails.application_id)
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        url: "applications/upload/file?final_certificate_uploaded=true",
        token: "Bearer " + this.user.token,
      },
    })
    return this.uploadRequest(request)
  }

  getReports = data => {
    const request = new Request({
      data: {
        ...data,
        url: "reports/clients/all",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAllApplications = page => {
    const request = new Request({
      data: {
        url: "applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAllEnvAuditApplications = page => {
    const request = new Request({
      data: {
        url: "environmental-audit/all-applications" + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  searchApplications = (data, page) => {
    let oneFound = false

    let url = "search"
    if (data?.search != "") {
      url = url + "?search=" + data.search
      oneFound = true
    }

    if (data?.service_name != "") {
      if (oneFound) {
        url = url + "&service_name=" + data.service_name
      } else {
        url = url + "?service_name=" + data.service_name
      }
      oneFound = true
    }

    if (data?.date_from != "") {
      if (oneFound) {
        url = url + "&date_from=" + data.date_from
      } else {
        url = url + "?date_from=" + data.date_from
      }
      oneFound = true
    }

    if (data?.date_to != "") {
      if (oneFound) {
        url = url + "&date_to=" + data.date_to
      } else {
        url = url + "?date_to=" + data.date_to
      }
      oneFound = true
    }

    if (data?.application_status != "") {
      if (oneFound) {
        url = url + "&application_status=" + data.application_status
      } else {
        url = url + "?application_status=" + data.application_status
      }
      oneFound = true
    }

    if (data?.officer_id != undefined) {
      if (oneFound) {
        url = url + "&officer_id=" + data.officer_id
      } else {
        url = url + "?officer_id=" + data.officer_id
      }
      oneFound = true
    }

    if (page != null) {
      url = url + "&page=" + page
    }

    if(data?.company_id != undefined)
    {
      url=url + "&company_id="+data.company_id
    }

    // console.log("filter url", url)
    
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }


  searchMessagingParticipants = (search, group) => {
    const request = new Request({
      data: {
        url: group + "/search?search=" + search,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  sendBulkNotification = (data) => {
    const url = "send-bulk-notification"
    const request = new Request({
      data: {
        ...data,
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getMessageHistory = (page) => {
    const url = "bulk-notification" + "?page=" + page
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getMessage = (id, page) => {
    const url = "bulk-notification/details/" + id + "?page=" + page
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getPlasticsStats = (id, page) => {
    const currentYear = new Date().getFullYear();
    const url = "plastics/dashboards/" + currentYear
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAttachments = (id) => {
    const url = "application/env-audit-staff-files/" + id
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAllServices = () => {
    const request = new Request({
      data: {
        url: "services",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  recallApplication = data => {
    const request = new Request({
      data: {
        url: "applications/recall/" + data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }


  getPlasticTypes = () => {
    const request = new Request({
      data: {
        url: "plastic-types",
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getQuantityMeasures = () => {
    const request = new Request({
      data: {
        url: "quantity-measures",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getConsumptionAreas = () => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getConsumptionAreaItems = (id) => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas/" + id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getLocalSuppliers = () => {
    const request = new Request({
      data: {
        url: "plastics/local-suppliers",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  saveApplication = appForm => {
    const service_id = 1
    const request = new Request({
      data: {
        ...appForm,
        client_id: this.user.id,
        service_id: service_id,
        is_submitted: true,
        url: "clients/applications/plastic-bags-authorization",
        token: "Bearer " + this.user.token,
      },
    })

    //console.log("app details" + request)
    return this.postRequest(request)
  }


  searchEnvironmentAuditApplications = (data, page = 1) => {
  const queryParams = new URLSearchParams()

  // Add each filter field if it's filled
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== "") {
      queryParams.append(key, value)
    }
  })

  // Add page number
  queryParams.append("page", page)

  const url = `environmental-applications?${queryParams.toString()}`

  const request = new Request({
    data: {
      url: url,
      token: "Bearer " + this.user.token,
    },
  })

  return this.getRequest(request)
}


}

export default Application
